import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import AdminPostSearchModule from "./AdminPostSearchModule";
import AdminSinglePost from "./AdminSinglePost";
import Spinner from "../components/Spinner";
import classes from "./adminInfoBlok.module.css";

const AdminInfoBlok = () => {
  const [isArray, setIsArray] = useState(false);
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();

  const getAllInfoBlokPosts = async () => {
    const { data } = await axiosPrivate.get("/getAllInfoBlokPosts");
    const isArray = await Array.isArray(data.result);
    if (isArray) {
      setIsArray(true);
    }
    return data;
  };
  const allInfoBlokPostsQuery = useQuery({
    queryKey: ["InfoBlokPosts"],
    queryFn: getAllInfoBlokPosts,
    staleTime: 0,
    refetchInterval: 1000 * 60 * 60 * 12,
  });

  if (allInfoBlokPostsQuery.isError) return <h2>Error...</h2>;

  const handleNewPost = () => {
    navigate("/betko-admin/kreiraj-novi-post", {
      state: "infoBlok",
    });
  };

  return (
    <div className={classes.container}>
      {allInfoBlokPostsQuery.isLoading ? (
        <Spinner />
      ) : (
        <>
          <h1>INFO BLOK</h1>
          <div className={classes.top}>
            {isArray && allInfoBlokPostsQuery.data.result !== undefined && (
              <AdminPostSearchModule type="infoBlok" />
            )}
            <button onClick={() => handleNewPost()} className={classes.btn}>
              Dodaj Novi
            </button>
          </div>
          <div className={classes.postContainer}>
            <div>
              {isArray && allInfoBlokPostsQuery.data.result !== undefined
                ? allInfoBlokPostsQuery.data.result.map((post) => {
                    return (
                      <AdminSinglePost
                        post={post}
                        key={post._id}
                        type="infoBlok"
                      />
                    );
                  })
                : allInfoBlokPostsQuery.data.msg}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminInfoBlok;
